import { render, staticRenderFns } from "./BlogsList.vue?vue&type=template&id=4d151ffe&scoped=true&"
import script from "./BlogsList.vue?vue&type=script&lang=js&"
export * from "./BlogsList.vue?vue&type=script&lang=js&"
import style0 from "./BlogsList.vue?vue&type=style&index=0&id=4d151ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d151ffe",
  null
  
)

export default component.exports